import React, { useEffect, useState } from 'react';
import { USER_VERIFICATION_STATUS } from '@enums';
import { useStore } from '@hooks';
import { Loader } from '@ui';
import { observer } from 'mobx-react';

const Rejected = observer(({ token }) => {
    const store = useStore();
    const { onInviteComplete, verification } = store.accountsStore;
    const [loading, setLoading] = useState(true);

    useEffect(async () => {
        if (verification?.status === USER_VERIFICATION_STATUS.PENDING) {
            await onInviteComplete('reject-invite', token);
            setLoading(false);
        } else {
            setLoading(false);
        }
    }, [verification?.status]);

    if (loading) {
        return <Loader />;
    }

    if (!verification) {
        return null;
    }

    if (verification.status === USER_VERIFICATION_STATUS.SUCCESS) {
        return (
            <p>
                You&apos;ve already used the link for successful verification. To leave the account, please request the
                account owner to remove you.
            </p>
        );
    }

    return <p>The invitation has been rejected.</p>;
});

export default Rejected;
